/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  FundFamilyEventData
} from '../../model/fundFamilyEventData'
import type {
  SecurityOwnershipCancelCorrectCreateDataRequest
} from '../../model/securityOwnershipCancelCorrectCreateDataRequest'
import type {
  SecurityOwnershipCancelCorrectFinalizeParams
} from '../../model/securityOwnershipCancelCorrectFinalizeParams'
import type {
  SecurityOwnershipCancelCorrectListParams
} from '../../model/securityOwnershipCancelCorrectListParams'
import type {
  SecurityOwnershipCancelCorrectParams
} from '../../model/securityOwnershipCancelCorrectParams'
import type {
  SecurityOwnershipCancelCorrectReadDataList
} from '../../model/securityOwnershipCancelCorrectReadDataList'
import type {
  SecurityOwnershipCreateDataRequest
} from '../../model/securityOwnershipCreateDataRequest'
import type {
  SecurityOwnershipEditDataRequest
} from '../../model/securityOwnershipEditDataRequest'
import type {
  SecurityOwnershipReadData
} from '../../model/securityOwnershipReadData'
import type {
  SecurityOwnershipUpdateParams
} from '../../model/securityOwnershipUpdateParams'
import type {
  SecurityOwnershipWithEntityDataList
} from '../../model/securityOwnershipWithEntityDataList'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Get security ownerships with entity data.
 */
export const securityOwnershipWithEntitiesRetrieve = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<SecurityOwnershipWithEntityDataList>(
      {url: `/fund-family/${fundFamilyId}/security-ownership/`, method: 'GET', signal
    },
      options);
    }
  

export const getSecurityOwnershipWithEntitiesRetrieveQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/security-ownership/`] as const;
    }

    
export const getSecurityOwnershipWithEntitiesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof securityOwnershipWithEntitiesRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof securityOwnershipWithEntitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSecurityOwnershipWithEntitiesRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof securityOwnershipWithEntitiesRetrieve>>> = ({ signal }) => securityOwnershipWithEntitiesRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof securityOwnershipWithEntitiesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SecurityOwnershipWithEntitiesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof securityOwnershipWithEntitiesRetrieve>>>
export type SecurityOwnershipWithEntitiesRetrieveQueryError = unknown

export const useSecurityOwnershipWithEntitiesRetrieve = <TData = Awaited<ReturnType<typeof securityOwnershipWithEntitiesRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof securityOwnershipWithEntitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSecurityOwnershipWithEntitiesRetrieveQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSecurityOwnershipWithEntitiesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof securityOwnershipWithEntitiesRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof securityOwnershipWithEntitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSecurityOwnershipWithEntitiesRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof securityOwnershipWithEntitiesRetrieve>>> = ({ signal }) => securityOwnershipWithEntitiesRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof securityOwnershipWithEntitiesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SecurityOwnershipWithEntitiesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof securityOwnershipWithEntitiesRetrieve>>>
export type SecurityOwnershipWithEntitiesRetrieveSuspenseQueryError = unknown

export const useSecurityOwnershipWithEntitiesRetrieveSuspense = <TData = Awaited<ReturnType<typeof securityOwnershipWithEntitiesRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof securityOwnershipWithEntitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSecurityOwnershipWithEntitiesRetrieveSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getSecurityOwnershipWithEntitiesRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getSecurityOwnershipWithEntitiesRetrieveQueryKey(fundFamilyId),
              queryFn: () => securityOwnershipWithEntitiesRetrieve(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Create a new SecurityOwnership.
 */
export const securityOwnershipCreate = (
    fundFamilyId: string,
    securityOwnershipCreateDataRequest: SecurityOwnershipCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<SecurityOwnershipReadData>(
      {url: `/fund-family/${fundFamilyId}/security-ownership/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: securityOwnershipCreateDataRequest
    },
      options);
    }
  


export const getSecurityOwnershipCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof securityOwnershipCreate>>, TError,{fundFamilyId: string;data: SecurityOwnershipCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof securityOwnershipCreate>>, TError,{fundFamilyId: string;data: SecurityOwnershipCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof securityOwnershipCreate>>, {fundFamilyId: string;data: SecurityOwnershipCreateDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  securityOwnershipCreate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SecurityOwnershipCreateMutationResult = NonNullable<Awaited<ReturnType<typeof securityOwnershipCreate>>>
    export type SecurityOwnershipCreateMutationBody = SecurityOwnershipCreateDataRequest
    export type SecurityOwnershipCreateMutationError = unknown

    export const useSecurityOwnershipCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof securityOwnershipCreate>>, TError,{fundFamilyId: string;data: SecurityOwnershipCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getSecurityOwnershipCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get a specific Commitment.
 */
export const securityOwnershipRetrieve = (
    fundFamilyId: string,
    id: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<SecurityOwnershipReadData>(
      {url: `/fund-family/${fundFamilyId}/security-ownership/${id}/`, method: 'GET', signal
    },
      options);
    }
  

export const getSecurityOwnershipRetrieveQueryKey = (fundFamilyId: string,
    id: string,) => {
    return [`/fund-family/${fundFamilyId}/security-ownership/${id}/`] as const;
    }

    
export const getSecurityOwnershipRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof securityOwnershipRetrieve>>, TError = unknown>(fundFamilyId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof securityOwnershipRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSecurityOwnershipRetrieveQueryKey(fundFamilyId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof securityOwnershipRetrieve>>> = ({ signal }) => securityOwnershipRetrieve(fundFamilyId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof securityOwnershipRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SecurityOwnershipRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof securityOwnershipRetrieve>>>
export type SecurityOwnershipRetrieveQueryError = unknown

export const useSecurityOwnershipRetrieve = <TData = Awaited<ReturnType<typeof securityOwnershipRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof securityOwnershipRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSecurityOwnershipRetrieveQueryOptions(fundFamilyId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSecurityOwnershipRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof securityOwnershipRetrieve>>, TError = unknown>(fundFamilyId: string,
    id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof securityOwnershipRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSecurityOwnershipRetrieveQueryKey(fundFamilyId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof securityOwnershipRetrieve>>> = ({ signal }) => securityOwnershipRetrieve(fundFamilyId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && id), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof securityOwnershipRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SecurityOwnershipRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof securityOwnershipRetrieve>>>
export type SecurityOwnershipRetrieveSuspenseQueryError = unknown

export const useSecurityOwnershipRetrieveSuspense = <TData = Awaited<ReturnType<typeof securityOwnershipRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof securityOwnershipRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSecurityOwnershipRetrieveSuspenseQueryOptions(fundFamilyId,id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getSecurityOwnershipRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,id: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,id } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && id) {
            return appQueryClient.prefetchQuery({
              queryKey: getSecurityOwnershipRetrieveQueryKey(fundFamilyId,id),
              queryFn: () => securityOwnershipRetrieve(fundFamilyId,id),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Update a specific Security Ownership.
 */
export const securityOwnershipUpdate = (
    fundFamilyId: string,
    id: string,
    securityOwnershipEditDataRequest: SecurityOwnershipEditDataRequest,
    params?: SecurityOwnershipUpdateParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<SecurityOwnershipReadData>(
      {url: `/fund-family/${fundFamilyId}/security-ownership/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: securityOwnershipEditDataRequest,
        params
    },
      options);
    }
  


export const getSecurityOwnershipUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof securityOwnershipUpdate>>, TError,{fundFamilyId: string;id: string;data: SecurityOwnershipEditDataRequest;params?: SecurityOwnershipUpdateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof securityOwnershipUpdate>>, TError,{fundFamilyId: string;id: string;data: SecurityOwnershipEditDataRequest;params?: SecurityOwnershipUpdateParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof securityOwnershipUpdate>>, {fundFamilyId: string;id: string;data: SecurityOwnershipEditDataRequest;params?: SecurityOwnershipUpdateParams}> = (props) => {
          const {fundFamilyId,id,data,params} = props ?? {};

          return  securityOwnershipUpdate(fundFamilyId,id,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SecurityOwnershipUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof securityOwnershipUpdate>>>
    export type SecurityOwnershipUpdateMutationBody = SecurityOwnershipEditDataRequest
    export type SecurityOwnershipUpdateMutationError = unknown

    export const useSecurityOwnershipUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof securityOwnershipUpdate>>, TError,{fundFamilyId: string;id: string;data: SecurityOwnershipEditDataRequest;params?: SecurityOwnershipUpdateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getSecurityOwnershipUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Deletes a security ownership from a closing
 */
export const securityOwnershipDelete = (
    fundFamilyId: string,
    id: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/security-ownership/${id}/`, method: 'DELETE'
    },
      options);
    }
  


export const getSecurityOwnershipDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof securityOwnershipDelete>>, TError,{fundFamilyId: string;id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof securityOwnershipDelete>>, TError,{fundFamilyId: string;id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof securityOwnershipDelete>>, {fundFamilyId: string;id: string}> = (props) => {
          const {fundFamilyId,id} = props ?? {};

          return  securityOwnershipDelete(fundFamilyId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SecurityOwnershipDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof securityOwnershipDelete>>>
    
    export type SecurityOwnershipDeleteMutationError = unknown

    export const useSecurityOwnershipDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof securityOwnershipDelete>>, TError,{fundFamilyId: string;id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getSecurityOwnershipDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets the cancel correct data for a security ownership
 */
export const securityOwnershipCancelCorrectList = (
    fundFamilyId: string,
    securityOwnershipId: string,
    params?: SecurityOwnershipCancelCorrectListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<SecurityOwnershipCancelCorrectReadDataList>(
      {url: `/fund-family/${fundFamilyId}/security-ownership/${securityOwnershipId}/cancel-correct`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSecurityOwnershipCancelCorrectListQueryKey = (fundFamilyId: string,
    securityOwnershipId: string,
    params?: SecurityOwnershipCancelCorrectListParams,) => {
    return [`/fund-family/${fundFamilyId}/security-ownership/${securityOwnershipId}/cancel-correct`, ...(params ? [params]: [])] as const;
    }

    
export const getSecurityOwnershipCancelCorrectListQueryOptions = <TData = Awaited<ReturnType<typeof securityOwnershipCancelCorrectList>>, TError = unknown>(fundFamilyId: string,
    securityOwnershipId: string,
    params?: SecurityOwnershipCancelCorrectListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof securityOwnershipCancelCorrectList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSecurityOwnershipCancelCorrectListQueryKey(fundFamilyId,securityOwnershipId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof securityOwnershipCancelCorrectList>>> = ({ signal }) => securityOwnershipCancelCorrectList(fundFamilyId,securityOwnershipId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && securityOwnershipId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof securityOwnershipCancelCorrectList>>, TError, TData> & { queryKey: QueryKey }
}

export type SecurityOwnershipCancelCorrectListQueryResult = NonNullable<Awaited<ReturnType<typeof securityOwnershipCancelCorrectList>>>
export type SecurityOwnershipCancelCorrectListQueryError = unknown

export const useSecurityOwnershipCancelCorrectList = <TData = Awaited<ReturnType<typeof securityOwnershipCancelCorrectList>>, TError = unknown>(
 fundFamilyId: string,
    securityOwnershipId: string,
    params?: SecurityOwnershipCancelCorrectListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof securityOwnershipCancelCorrectList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSecurityOwnershipCancelCorrectListQueryOptions(fundFamilyId,securityOwnershipId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSecurityOwnershipCancelCorrectListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof securityOwnershipCancelCorrectList>>, TError = unknown>(fundFamilyId: string,
    securityOwnershipId: string,
    params?: SecurityOwnershipCancelCorrectListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof securityOwnershipCancelCorrectList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSecurityOwnershipCancelCorrectListQueryKey(fundFamilyId,securityOwnershipId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof securityOwnershipCancelCorrectList>>> = ({ signal }) => securityOwnershipCancelCorrectList(fundFamilyId,securityOwnershipId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && securityOwnershipId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof securityOwnershipCancelCorrectList>>, TError, TData> & { queryKey: QueryKey }
}

export type SecurityOwnershipCancelCorrectListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof securityOwnershipCancelCorrectList>>>
export type SecurityOwnershipCancelCorrectListSuspenseQueryError = unknown

export const useSecurityOwnershipCancelCorrectListSuspense = <TData = Awaited<ReturnType<typeof securityOwnershipCancelCorrectList>>, TError = unknown>(
 fundFamilyId: string,
    securityOwnershipId: string,
    params?: SecurityOwnershipCancelCorrectListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof securityOwnershipCancelCorrectList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSecurityOwnershipCancelCorrectListSuspenseQueryOptions(fundFamilyId,securityOwnershipId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getSecurityOwnershipCancelCorrectListLoader = (queryParamsOrFn?: (SecurityOwnershipCancelCorrectListParams | ((params: Params) => SecurityOwnershipCancelCorrectListParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,securityOwnershipId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,securityOwnershipId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && securityOwnershipId) {
            return appQueryClient.prefetchQuery({
              queryKey: getSecurityOwnershipCancelCorrectListQueryKey(fundFamilyId,securityOwnershipId, queryParams),
              queryFn: () => securityOwnershipCancelCorrectList(fundFamilyId,securityOwnershipId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Cancel Correct a security ownership.
 */
export const securityOwnershipCancelCorrect = (
    fundFamilyId: string,
    securityOwnershipId: string,
    securityOwnershipCancelCorrectCreateDataRequest: SecurityOwnershipCancelCorrectCreateDataRequest,
    params?: SecurityOwnershipCancelCorrectParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyEventData>(
      {url: `/fund-family/${fundFamilyId}/security-ownership/${securityOwnershipId}/cancel-correct`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: securityOwnershipCancelCorrectCreateDataRequest,
        params
    },
      options);
    }
  


export const getSecurityOwnershipCancelCorrectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof securityOwnershipCancelCorrect>>, TError,{fundFamilyId: string;securityOwnershipId: string;data: SecurityOwnershipCancelCorrectCreateDataRequest;params?: SecurityOwnershipCancelCorrectParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof securityOwnershipCancelCorrect>>, TError,{fundFamilyId: string;securityOwnershipId: string;data: SecurityOwnershipCancelCorrectCreateDataRequest;params?: SecurityOwnershipCancelCorrectParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof securityOwnershipCancelCorrect>>, {fundFamilyId: string;securityOwnershipId: string;data: SecurityOwnershipCancelCorrectCreateDataRequest;params?: SecurityOwnershipCancelCorrectParams}> = (props) => {
          const {fundFamilyId,securityOwnershipId,data,params} = props ?? {};

          return  securityOwnershipCancelCorrect(fundFamilyId,securityOwnershipId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SecurityOwnershipCancelCorrectMutationResult = NonNullable<Awaited<ReturnType<typeof securityOwnershipCancelCorrect>>>
    export type SecurityOwnershipCancelCorrectMutationBody = SecurityOwnershipCancelCorrectCreateDataRequest
    export type SecurityOwnershipCancelCorrectMutationError = unknown

    export const useSecurityOwnershipCancelCorrect = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof securityOwnershipCancelCorrect>>, TError,{fundFamilyId: string;securityOwnershipId: string;data: SecurityOwnershipCancelCorrectCreateDataRequest;params?: SecurityOwnershipCancelCorrectParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getSecurityOwnershipCancelCorrectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Finalize security ownership cancel correct.
 */
export const securityOwnershipCancelCorrectFinalize = (
    fundFamilyId: string,
    securityOwnershipId: string,
    params?: SecurityOwnershipCancelCorrectFinalizeParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/security-ownership/${securityOwnershipId}/cancel-correct`, method: 'PATCH',
        params
    },
      options);
    }
  


export const getSecurityOwnershipCancelCorrectFinalizeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof securityOwnershipCancelCorrectFinalize>>, TError,{fundFamilyId: string;securityOwnershipId: string;params?: SecurityOwnershipCancelCorrectFinalizeParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof securityOwnershipCancelCorrectFinalize>>, TError,{fundFamilyId: string;securityOwnershipId: string;params?: SecurityOwnershipCancelCorrectFinalizeParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof securityOwnershipCancelCorrectFinalize>>, {fundFamilyId: string;securityOwnershipId: string;params?: SecurityOwnershipCancelCorrectFinalizeParams}> = (props) => {
          const {fundFamilyId,securityOwnershipId,params} = props ?? {};

          return  securityOwnershipCancelCorrectFinalize(fundFamilyId,securityOwnershipId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SecurityOwnershipCancelCorrectFinalizeMutationResult = NonNullable<Awaited<ReturnType<typeof securityOwnershipCancelCorrectFinalize>>>
    
    export type SecurityOwnershipCancelCorrectFinalizeMutationError = unknown

    export const useSecurityOwnershipCancelCorrectFinalize = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof securityOwnershipCancelCorrectFinalize>>, TError,{fundFamilyId: string;securityOwnershipId: string;params?: SecurityOwnershipCancelCorrectFinalizeParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getSecurityOwnershipCancelCorrectFinalizeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    